module.exports = __webpack_public_path__ + "themes/mf/img/prize-4.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-4.png
// module id = 92
// module chunks = 3